import React from "react";
import { Empty } from "antd";
import { numberWithCommas } from "../../utils";

const STATUS_META = {
  DeliveredToTerminal: {
    tone: "success",
    label: "Delivered",
  },
  SENT: {
    tone: "info",
    label: "Queued",
  },
  SENT_RETRIED: {
    tone: "info",
    label: "Retried",
  },
  InvalidMsisdn: {
    tone: "danger",
    label: "Invalid number",
  },
  DeliveryImpossible: {
    tone: "warning",
    label: "Delivery impossible",
  },
  AbsentSubscriber: {
    tone: "warning",
    label: "Absent subscriber",
  },
  "Exception sending ": {
    tone: "danger",
    label: "Exception",
  },
};

function DashboardCard({ dashData }) {
  const items = dashData?.ststusSummary ?? [];

  if (!items.length) {
    return (
      <div className="dashboard-account-empty-state compact">
        <Empty description="No SMS status summary available" />
      </div>
    );
  }

  return (
    <div className="dashboard-status-grid">
      {items.map((item) => {
        const meta = STATUS_META[item?.msgStatus] ?? {
          tone: "neutral",
          label: item?.msgStatus,
        };

        return (
          <article
            key={item?.msgStatus}
            className={`dashboard-status-card tone-${meta.tone}`}
          >
            <div className="dashboard-status-card-top">
              <span className="dashboard-status-card-label">{meta.label}</span>
              <span className="dashboard-status-card-percent">
                {item?.msgPerCent ?? 0}%
              </span>
            </div>

            <strong className="dashboard-status-card-total">
              {numberWithCommas(item?.msgCount)}
            </strong>

            <p className="dashboard-status-card-foot">
              Original status: {item?.msgStatus}
            </p>
          </article>
        );
      })}
    </div>
  );
}

export default DashboardCard;
